/**
 * TAMIX SAAS PLATFORM - Main Layout Component
 * ===========================================
 * Generated: 2025-09-22 - Session 6 Sprint 0
 * Protected layout with navigation and sidebar
 */

import React from 'react'
import { Outlet } from 'react-router-dom'
import Navbar from './Navbar'
import Sidebar from './Sidebar'

const Layout: React.FC = () => {
  return (
    <div className="d-flex vh-100">
      {/* Sidebar */}
      <Sidebar />
      
      {/* Main Content Area */}
      <div className="flex-fill d-flex flex-column">
        {/* Top Navigation */}
        <Navbar />
        
        {/* Page Content */}
        <main className="flex-fill p-3 bg-light overflow-auto">
          <div className="container-fluid">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  )
}

export default Layout